import { useState } from 'react';

export type ColumnConfig<T> = {
  field: keyof T | string;
  label: string;
  defaultVisible: boolean;
}

export function useColumnVisibility<T>(columns: ColumnConfig<T>[]) {
  const [visibleColumns, setVisibleColumns] = useState<Set<string>>(
    new Set(columns.filter(col => col.defaultVisible).map(col => col.field.toString()))
  );

  const toggleColumn = (field: keyof T | string) => {
    const newVisibleColumns = new Set(visibleColumns);
    if (newVisibleColumns.has(field.toString())) {
      newVisibleColumns.delete(field.toString());
    } else {
      newVisibleColumns.add(field.toString());
    }
    setVisibleColumns(newVisibleColumns);
  };

  const isColumnVisible = (field: keyof T | string) => visibleColumns.has(field.toString());

  return {
    visibleColumns,
    toggleColumn,
    isColumnVisible
  };
} 